import React from 'react'
import widget_initial_state from './widget_initial_state'

export default React.createContext(widget_initial_state)
